<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="900px">
    <template v-slot:activator="{ on }">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            style="right:50px; top:40px;"
            class="mt-5 mr-0"
            v-on="on"
            absolute
            dark
            small
            fab
            top
            right
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar grupos de despesas</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="dialogShow = false">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span
          class="title grey--text text--darken-2"
        >{{formData.id ? 'Editar grupo de despesas' : 'Criar grupos de despesas'}}</span>
      </v-card-title>
      <v-card-text class="mt-0 pt-0 dialogMinHeightCard">
        <v-form ref="rgrExpForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 px-3>
                <v-select
                  :rules="$store.state.formRules.requiredSelect"
                  v-model="formData.condominium_id"
                  :disabled="userGrpExp.length ? true : false"
                  :items="condominiums"
                  item-text="name_fantasy"
                  item-value="id"
                  label="Selecione o condomínio"
                ></v-select>
              </v-flex>
              <v-flex xs6 px-3>
                <v-select
                  return-object
                  v-model="formData.expenseGroup_Id"
                  :items="expensesGroups"
                  :disabled="!formData.condominium_id"
                  item-text="name"
                  item-value="id"
                  append-icon="library_add"
                  @click:append="addExpense(formData.expenseGroup_Id)"
                  label="Selecione um grupo de despesas"
                >
                  <template v-slot:selection="{ item }">Cod.: {{item.code}} - {{item.name}}</template>
                  <template v-slot:item="{ item }">Cod.: {{item.code}} - {{item.name}}</template>
                </v-select>
              </v-flex>
              <h4
                class="mb-2 grey--text text--darken-1 pl-4"
                v-if="userGrpExp.length"
              >Meus grupos de despesas</h4>
              <p
                v-if="!userGrpExp.length"
                style="width:100%"
                class="body-2 text-xs-center pt-5"
              >Selecione um condomínio e um grupo de despesas para criar o seu padrão de despesas.</p>
              <v-layout
                v-for="(expense, i) in userGrpExp "
                :key="i"
                row
                wrap
                mx-3
                px-4
                py-2
                mb-3
                grey
                roundBox
                lighten-4
              >
                <v-flex xs12 class="text-xs-left">
                  <code class="pa-1 codeClass">
                    <b>Cod. {{expense.defCode}} - {{expense.defName}}</b>
                  </code>
                  <span
                    class="caption pl-2 grey--text text--darken-1"
                  >Código e nome padrão no sistema</span>
                  <!-- <span><b>JARDINAGEM E PAISAGISMO</b></span> -->
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="expense.code_user"
                    label="Meu código"
                    :rules="$store.state.formRules.required"
                  />
                </v-flex>
                <v-flex xs7 class="pl-5">
                  <v-text-field
                    v-model="expense.name_user"
                    label="Descrição"
                    :rules="$store.state.formRules.required"
                  />
                </v-flex>
                <v-flex xs1 class="pt-3">
                  <v-btn flat icon color="primary" @click="removeExpense(expense.default_id)">
                    <v-icon style="font-size:24px;">delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="dialogShow = false">Cancelar</v-btn>
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const rgrExpDefaultForm = {
  name: "",
  condominium_id: "",
  expenseGroup_Id: null,
  permissions_id: []
};
export default {
  name: "profilesForm",
  components: {},
  props: {
    addButton: Boolean,
    closeForm: Function,
    reloadUserExpenseGroups: Function,
    dialog: Boolean,
    editFormData: Object
  },
  data: function() {
    return {
      userGrpExp: [],
      noChangeCondominium: false,
      expensesGroups: [],
      dialogShow: false,
      condominium_id: "",
      condominiums: [],
      viewForm: false,
      permissionsList: [],
      formData: { ...rgrExpDefaultForm },
      validForm: true
    };
  },
  computed: {},
  watch: {
    dialogShow: function(val) {
      //console.log(val);
      if (val) {
      } else {
        this.resetDialog();
      }
    }
  },
  mounted() {
    this.getComdominiums();
    this.getExpensesGroups();
    this.getPermissions();
  },
  methods: {
    resetDialog() {
      this.formData = rgrExpDefaultForm;
      this.$refs.rgrExpForm.resetValidation();
      this.userGrpExp = [];
      this.expensesGroups.map(exp => {
        exp.disabled = false;
        return exp;
      });
    },
    removeExpense(id) {
      var index = this.userGrpExp.findIndex(exp => exp.default_id === id);
      this.userGrpExp.splice(index, 1);
      var ind = this.expensesGroups.findIndex(expDef => expDef.id === id);
      this.expensesGroups[ind].disabled = false;
    },
    addExpense(item) {
      if (!item) {
        return;
      }
      item.disabled = true;
      let createNewLine = async () => {
        let newLine = {};
        newLine.default_id = item.id;
        newLine.condominium_id = this.formData.condominium_id;
        newLine.defCode = item.code;
        newLine.defName = item.name;
        newLine.code_user = "";
        newLine.name_user = "";
        await this.userGrpExp.unshift({ ...newLine });
        console.log(this.userGrpExp);
      };
      createNewLine().then(_ => {
        this.formData.expenseGroup_Id = "";
        this.$refs.rgrExpForm.resetValidation();
      });
    },
    openForm() {
      this.dialogShow = true;
    },
    getComdominiums() {
      let obj = {
        url: "/api/condominium",
        query: "",
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.condominiums = response.data;
      });
    },
    getExpensesGroups() {
      let obj = {
        url: "/api/defaultExpenseGroup",
        query: "",
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.expensesGroups = response.data.map(exp => {
          exp.disabled = false;
          return exp;
        });
      });
    },
    getPermissions() {
      let obj = {
        url: "/api/permission",
        query: "",
        method: "get",
        noLoader: true
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.permissionsList = response.data;
      });
    },
    doSave() {
      if (!this.$refs.rgrExpForm.validate()) {
        return;
      }
      let query = { groups: this.userGrpExp };
      let obj = {
        url: "/api/expenseGroup",
        query: query,
        method: "post"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        let obj = {
          message: `${response.data.message}`,
          title: "Sucesso",
          callback: _ => {
            this.reloadUserExpenseGroups();
          },
          type: "success",
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: "Não", show: false }
        };
        this.$store.commit("confirmMessage/showConfirmMessage", obj);
      });
    }
  }
};
</script>

<style>
.permissionTitle.red--text,
.permissionTitle.red--text::before {
  content: "*";
  color: #f44336 !important;
}
.codeClass {
  background: #fff;
  color: darkblue;
}
.roundBox {
  border-radius: 5px;
}

.dialogMinHeightCard {
  min-height: 300px;
}
</style>
